var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.viewData.loadingPage
    ? _c("loading-list")
    : _vm.viewData.success
    ? _c(
        "b-container",
        [
          _c("b-alert", { attrs: { show: "", variant: "success" } }, [
            _c("h4", { staticClass: "alert-heading" }, [
              _vm._v("Cadastro ativo!")
            ]),
            _vm._v(" "),
            this.isAdmin
              ? _c("p", [
                  _c("a", { attrs: { href: "/#/login" } }, [
                    _vm._v("Clique aqui para entrar na aplicação.")
                  ])
                ])
              : _c("p", [_vm._v("Acesse o aplicativo para continuar.")]),
            _vm._v(" "),
            _c("hr")
          ])
        ],
        1
      )
    : _c(
        "b-form",
        { staticClass: "form-signin" },
        [
          _c("img", {
            staticClass: "mb-4",
            staticStyle: { width: "19em" },
            attrs: { src: "/images/logo_veins.png", alt: "" }
          }),
          _vm._v(" "),
          _c("h1", { staticClass: "h3 mb-3 font-weight-normal" }, [
            _vm._v("Ativando seu cadastro...")
          ]),
          _vm._v(" "),
          _c("error-container", {
            attrs: { errors: _vm.viewData.errors || [] }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-lg btn-block",
              attrs: { type: "button", disabled: _vm.viewData.loading },
              on: { click: _vm.save }
            },
            [
              _vm.viewData.loading
                ? _c("b-icon", {
                    attrs: { icon: "three-dots", animation: "cylon" }
                  })
                : _c("span", [_vm._v("Entrar")])
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }